module.exports = __webpack_public_path__ + "img/exercise_open.e5facbde.png";